const euromillionsLogoImage = {
  src: '/incoming/21348927-v0-euro-millions-logo.png',
  alt: 'Euromillions logo',
  width: 109,
  height: 31,
  crops: {},
} as const

const expectedDimensions = { width: 109, height: 31 } as const

const constraints = {
  desktop: expectedDimensions,
  tablet: expectedDimensions,
  mobile: expectedDimensions,
  mobileSmall: expectedDimensions,
} as const

export { euromillionsLogoImage, expectedDimensions, constraints }
